module.exports = __webpack_public_path__ + "static/media/piano-langdon-street.752ed973.jpg";